<div class="container">
    @if (!data.hasId()) {
    <h2
        mat-dialog-title
        class="cut-long-text"
    >{{ "new_record" | transloco }}</h2>
    } @else {
    <h2
        mat-dialog-title
        class="cut-long-text"
    >{{ "edit_record" | transloco }}</h2>
    }
    <mat-divider></mat-divider>
    <form
        [formGroup]="formGroup"
        class="pixl-form"
    >
        <mat-dialog-content class="grid">
            <mat-form-field class="full-width">
                <mat-label>{{ "supertitle" | transloco }}</mat-label>
                <input
                    matInput
                    type="text"
                    required
                    placeholder=""
                    formControlName="preTitle"
                />
                <mat-error>{{ checkForErrors(formGroup.controls["preTitle"]) }}</mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>{{ "title" | transloco }}</mat-label>
                <input
                    matInput
                    type="text"
                    required
                    placeholder=""
                    formControlName="title"
                />
                <mat-error>{{ checkForErrors(formGroup.controls["title"]) }}</mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>{{ "description" | transloco }}</mat-label>
                <input
                    matInput
                    type="text"
                    required
                    placeholder=""
                    formControlName="description"
                />
                <mat-error>{{ checkForErrors(formGroup.controls["description"]) }}</mat-error>
            </mat-form-field>

            <div class="preview-container border-area full-width">
                <div class="content">
                    <div>
                        <button
                            class="extend-button"
                            mat-stroked-button
                            (click)="openImageChoice()"
                        >
                            <mat-icon>add_photo_alternate</mat-icon>
                            {{ "select_preview_image" | transloco }}
                        </button>
                    </div>

                    @if (getImageName() && getImageName().length > 0) {
                    <div>
                        <div class="media-container">
                            <div class="media-item">
                                <div class="media-item">
                                    <img
                                        src="{{ imageUrl() }}"
                                        alt=""
                                        class="preview"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-1">
                        <span class="info cut-long-text">{{ getImageName() }}</span>
                    </div>

                    <div>
                        <button
                            mat-icon-button
                            (click)="deleteMediaEntry()"
                        >
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                    }
                </div>
            </div>

            @if (isZavAdmin) {
            <div class="content-array-wrapper border-area full-width">
                <div
                    formArrayName="content"
                    class="content-array-container"
                >
                    @for (ctrl of contentControls.controls; track ctrl) {
                    <div class="content-item-row">
                        <mat-form-field class="content-input">
                            <input
                                matInput
                                placeholder="Content"
                                [formControlName]="contentControls.controls.indexOf(ctrl)"
                            />
                        </mat-form-field>

                        <button
                            mat-icon-button
                            color="warn"
                            type="button"
                            class="remove-button"
                            (click)="removeContent(contentControls.controls.indexOf(ctrl))"
                            aria-label="Remove content item"
                        >
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                    }
                </div>

                <div class="add-button-wrapper">
                    <button
                        mat-raised-button
                        color="primary"
                        type="button"
                        (click)="addContent()"
                    >
                        <mat-icon>add</mat-icon>
                        {{ "add_content" | transloco }}
                    </button>
                </div>
            </div>
            }

            <div class="filter-item">
                <pixl-state-cb
                    [required]="true"
                    [initValue]="status"
                    (onStateChange)="statusChanged($event)"
                />
            </div>

            @if (schoolClasses$ | async; as sc) {
            <mat-form-field appearance="outline">
                <mat-label>{{ "class" | transloco }}</mat-label>
                <mat-select
                    formControlName="schoolClasses"
                    multiple
                >
                    @for (schoolClass of sc; track schoolClass) {
                    <mat-option [value]="schoolClass">{{ "grade" | transloco }} {{ schoolClass.grade }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            }

            <mat-form-field class="full-width">
                <mat-label>{{ "consumer" | transloco }}</mat-label>
                <mat-select formControlName="consumer">
                    @for (consumer of consumers; track consumer) {
                    <mat-option [value]="consumer">{{ consumer.name }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field
                appearance="outline"
                class="full-width"
            >
                <mat-label>{{ "subjects_professions" | transloco }}</mat-label>
                <mat-select
                    formControlName="subjects"
                    multiple
                >
                    @for (subject of subjects; track subject) {
                    <mat-option [value]="subject">{{ subject.name }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <div class="border-area full-width">
                <div class="learning-unit-select mt-2">
                    <pixl-multi-combo-search
                        [label]="'learning_units_label' | transloco"
                        [observable$]="learningUnits$"
                        [namingColumn]="'title'"
                        [externalSearch]="true"
                        (onStateChange)="receiveData($event)"
                        (onSearchChange)="receiveSearchQuery($event)"
                        [(selectedValues)]="learningUnits"
                    />
                </div>

                <div class="mb-1">{{ "arrange_drag_drop" | transloco }}</div>
                <div
                    cdkDropList
                    class="learning-unit-list"
                    (cdkDropListDropped)="reorderLearningUnits($event)"
                >
                    @for (learningUnit of formGroup.get("learningUnits")?.value; track learningUnit.id) {
                    <div
                        class="learning-unit-box"
                        cdkDrag
                    >
                        {{ learningUnit.title }}
                    </div>
                    }
                </div>
            </div>
        </mat-dialog-content>
    </form>
    <mat-divider></mat-divider>
    <mat-dialog-actions>
        <button
            mat-raised-button
            (click)="onCancel()"
        >{{ "abort" | transloco }}</button>
        <button
            mat-raised-button
            (click)="onSave()"
            [disabled]="!formGroup.valid || formGroup.controls['title'].value === ''"
        >{{ "save" | transloco }}</button>
    </mat-dialog-actions>
</div>